import styled from 'styled-components';

import { RadiusConfig } from 'enable-ui';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  width: 100%;

  .list-institution {
    background: ${COLOR_CONFIG.white};
  }
`;

export const CustomButton = styled.div`
  button {
    display: flex;
    align-items: center;
    gap: 6px;
    background: ${COLOR.primary['primary-6']};
    color: ${COLOR_CONFIG.white};
    font-size: 16px;
    line-height: calc(22 / 16);
    border: none;
    border-radius: ${RadiusConfig.sm}px;
    padding: 11px 24px;
    &:hover {
      background-color: #fd8a24;
      color: #fffdf7;
    }
  }

  svg {
    margin-right: 0 !important;
  }

  svg path {
    stroke: ${COLOR_CONFIG.white}!important;
  }
`;
